import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const SurveyLayout: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100vw',
                minHeight: '100vh',
            }}
        >
            <Outlet />
        </Box>
    );
};

export default SurveyLayout;
